// IMPORTANT: THIS FILE IS AUTO GENERATED AND OVERWRITTEN ON BUILD!
/* tslint:disable */
export const GITVERSION = {
  "dirty": true,
  "raw": "12.15.0-8-gb84357c0-dirty",
  "hash": "gb84357c0",
  "distance": 8,
  "tag": "12.15.0",
  "semver": {
    "options": {
      "loose": false,
      "includePrerelease": false
    },
    "loose": false,
    "raw": "12.15.0",
    "major": 12,
    "minor": 15,
    "patch": 0,
    "prerelease": [],
    "build": [],
    "version": "12.15.0"
  },
  "suffix": "8-gb84357c0-dirty",
  "semverString": "12.15.0+8.gb84357c0"
};
export const DATESTAMP = '2024-06-12 11:05:10';
/* tslint:enable */
